module.exports = "https://static.wanderu.com/ui-react/_next/static/media/ie.5ecf710f.svg";